<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">跑腿信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>跑腿订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="学校：">
        <el-select v-model="formInline.schoolId" clearable>
          <el-option label="全部" value=""/>
          <el-option v-for="item in schoolSelect" :key="item.id" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="项目类型：">
        <el-select v-model="formInline.projectType" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="快递代取" value="1"></el-option>
          <el-option label="帮我取" value="2"></el-option>
          <el-option label="帮我送" value="3"></el-option>
          <el-option label="帮我买" value="4"></el-option>
          <el-option label="万能帮" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="formInline.statusList" style="width: 300px" multiple clearable>
          <el-option label="已取消" value="-1"></el-option>
          <el-option label="已发布（待支付）" value="0"></el-option>
          <el-option label="已发布（已支付）" value="1"></el-option>
          <el-option label="已接单" value="2"></el-option>
          <el-option label="已送达" value="3"></el-option>
          <el-option label="已签收" value="4"></el-option>
          <el-option label="系统自动签收" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <!--        <el-button size="small" type="primary" icon="el-icon-plus" @click="couponAdd">添加</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="commonMsgData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="schoolName" width="160" label="发布学校" show-overflow-tooltip/>
      <el-table-column label="发布人信息" width="100" show-overflow-tooltip>
        <template v-slot:default="scope">
          <div slot="reference" class="name-wrapper">
            <p>{{ scope.row.publishName }}</p>
            <p>{{ scope.row.publishMobile }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="gmtCreate" label="发布时间" width="140" show-overflow-tooltip/>
      <el-table-column align="center" prop="projectTypeName" label="项目类型"/>
      <el-table-column label="取货地址" width="160" show-overflow-tooltip>
        <template v-slot:default="scope">
          <p>{{ scope.row.pickupContacts }} {{ scope.row.pickupPhone }}</p>
          <p>{{ scope.row.pickupAddress }}</p>
        </template>
      </el-table-column>
      <el-table-column label="送货地址" width="160" show-overflow-tooltip>
        <template v-slot:default="scope">
          <p>{{ scope.row.deliverContacts }} {{ scope.row.deliverPhone }}</p>
          <p>{{ scope.row.deliverAddress }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="itemWeight" label="物品信息" :formatter="itemWeightFormatter" width="100"/>
      <el-table-column align="center" prop="pickupCode" label="取件码" show-overflow-tooltip/>
      <el-table-column align="center" label="万能帮时间" width="160">
        <template v-slot:default="scope">
          <div slot="reference" class="name-wrapper">
            <p>{{ scope.row.workStartTime }}</p>
            <p>{{ scope.row.workEndTime }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="remarks" label="跑腿说明" width="160" show-overflow-tooltip/>
      <el-table-column label="总额" width="80" align="center">
        <template v-slot:default="scope">
          <el-popover trigger="hover" placement="top">
            <p>计算公式: 总价 = 基础+加钱-优惠券</p>
            <p>基础: {{ scope.row.baseAmount }}元</p>
            <p>加钱: {{ scope.row.increasedAmount }}元</p>
            <p>优惠券: {{ scope.row.couponAmount != null ? scope.row.couponAmount : "-" }}元</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.actualAmount }}元</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="commission" label="佣金" width="80" :formatter="amountFormat"/>
      <el-table-column label="接单人信息" width="100" show-overflow-tooltip>
        <template v-slot:default="scope">
          <div slot="reference" class="name-wrapper">
            <p>{{ scope.row.receiveName }}</p>
            <p>{{ scope.row.receiveMobile }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="receiveTime" label="接单时间" width="160" show-overflow-tooltip/>
<!--      <el-table-column align="center" prop="urlLink" label="小程序短链接" width="200" show-overflow-tooltip/>-->
      <el-table-column align="center" prop="status" label="状态" :formatter="statusFormatter" width="140" fixed="right"/>
      <el-table-column align="center" label="操作" width="100" fixed="right">
        <template v-slot:default="scope">
          <el-row>
            <el-button size="mini" v-if="scope.row.status==-1" type="text" style="color: red; text-decoration: underline;" @click="remove(scope.row.id)">删除</el-button>
          </el-row>
          <el-row>
            <el-button size="mini" v-if="scope.row.status==2" type="text" style=" text-decoration: underline;" @click="cancel(scope.row.id)">发布人撤销</el-button>
          </el-row>
          <el-row>
            <el-button size="mini" v-if="scope.row.status==2" type="text" style="text-decoration: underline;" @click="receiveCancel(scope.row.id)">接单人撤销</el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {runErrandsPage, runErrandsDelete, runErrandsCancel, runErrandsReceiveCancel} from '../../api/runErrandsMG'
import {schoolList} from '../../api/schoolMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      commonMsgData: [],  //消息通知数据
      loading: false, //是显示加载
      schoolSelect: [], //学校列表
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
        schoolId: "",
        projectType: "",
        statusList: []
      },
      editFormVisible: false, //新增框是否显示
      editForm: {
        dateTimeRange: null,
        amount: '',
        issuedNum: ''
      },
      rules: {
        dateTimeRange: [{type: 'array', required: true, message: '请选择优惠券有效期', trigger: 'blur'}],
        amount: [{required: true, message: '请输入优惠券金额', trigger: 'blur'}],
        issuedNum: [{required: true, message: '请输入优惠券发放数量', trigger: 'blur'}]
      },
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */
  created() {
    this.querySchoolList()
    this.getdata(this.formInline)

  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //查询学校列表
    querySchoolList: function () {
      schoolList().then(res => {
        this.loading = false
        if (res.code == 0) {
          res.data.forEach(item => {
            this.schoolSelect.push(item);
          })
        } else {
          this.$message({type: 'info', message: res.msg})
        }
      }).catch(() => {
        this.$message({type: 'info', message: res.msg})
      })
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      runErrandsPage(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.commonMsgData = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //优惠券新增
    couponAdd() {
      this.editFormVisible = true;
      this.editForm.dateTimeRange = null,
        this.editForm.amount = 1;
      this.editForm.issuedNum = 1;
    },
    //新增、编辑界面保存
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editForm.startTime = this.editForm.dateTimeRange[0];
          this.editForm.endTime = this.editForm.dateTimeRange[1];
          let params = {
            'useScope': 'RUN_ERRANDS',
            'startTime': this.editForm.dateTimeRange[0],
            'endTime': this.editForm.dateTimeRange[1],
            'amount': this.editForm.amount,
            'issuedNum': this.editForm.issuedNum
          }
          couponSave(params).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 0) {
              this.getdata(this.formInline)
              this.$message({type: 'success', message: '保存成功！'})
              this.$refs['editForm'].resetFields();
            } else {
              this.$message({type: 'warning', message: res.msg})
            }
          }).catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('保存失败，请稍后再试！')
          })
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      this.editFormVisible = false
    },
    //发布人取消
    cancel(id) {
      this.$confirm('发布人撤销会回退支付金额，请谨慎操作?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        runErrandsCancel({'id': id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '撤销成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //接单人取消
    receiveCancel(id) {
      this.$confirm('接单人撤销订单回退至接单大厅，请谨慎操作?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        runErrandsReceiveCancel({'id': id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '撤销成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //删除
    remove(id) {
      this.$confirm('删除无法撤回，确认删除?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        runErrandsDelete({'id': id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '删除成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //物品重量格式化
    itemWeightFormatter: function (row, column) {
      let name = "";
      switch (row.itemWeight) {
        case 1:
          name = "小件";
          break;
        case 2:
          name = "中件";
          break;
        case 2:
          name = "大件";
          break;
      }
      if (row.itemNum != null) {
        name += "（" + row.itemNum + "件）";
      }
      return name;
    },
    //金额格式化
    amountFormat(row) {
      return row.commission + " 元";
    },
    //状态格式化
    statusFormatter: function (row, column) {
      let name = "";
      switch (row.status) {
        case -1:
          name = "已取消";
          break;
        case 0:
          name = "已发布（待支付）";
          break;
        case 1:
          name = "已发布（已支付）";
          break;
        case 2:
          name = "已接单";
          break;
        case 3:
          name = "已送达";
          break;
        case 4:
          name = "已签收";
          break;
        case 5:
          name = "系统自动签收";
          break;
      }
      return name;
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/runErrands.vue